<script lang="js" setup>
import {defineProps} from "vue";

defineProps({
  title: {
    type: String,
    required: true
  }
});
</script>

<template>
  <div class="flex flex-col gap-y-8 lg:gap-y-12">
    <h3 class="font-semibold">{{ title }}</h3>
    <ul class="flex flex-col gap-y-3 lg:gap-y-5">
      <slot />
    </ul>
  </div>
</template>

<style scoped></style>
